import { StyleProps } from "../../types";
export var TrackingEvent;
(function (TrackingEvent) {
    TrackingEvent["CLICK"] = "click";
    TrackingEvent["IMPRESSION"] = "impression";
})(TrackingEvent || (TrackingEvent = {}));
//# sourceMappingURL=types.js.map